import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalBody } from 'reactstrap';
import styles from './styles.module.scss';

const PlanModal = ({ plan, isOpen, onClose, onCtaClick }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size="xl">
      <ModalBody className={styles.planModal}>
        <div className={styles.header}>
          <div className={styles.imageContainer}>
            <img src={plan.image_file_name} alt="" />
          </div>
          <div className={styles.mainContainer}>
            <h1>{plan.title}</h1>
            <h5>${plan.price}</h5>
            <h5>{plan.instruction_hours} hours</h5>
            <p>{plan.instructor_intro}</p>
            <button className="apple font-heavy" onClick={onCtaClick}>
              Purchase This Service
            </button>
          </div>
          <div className={styles.closeContainer}>
            <FontAwesomeIcon
              icon="times"
              className="pointer"
              size="2x"
              onClick={onClose}
            />
          </div>
        </div>
        {plan.target_audience && (
          <div className={styles.whoContainer}>
            <h3 className={styles.whoHeader}>Who</h3>
            <div
              className={styles.who}
              dangerouslySetInnerHTML={{ __html: plan.target_audience }}
            />
            <hr />
          </div>
        )}
        {plan.preset_dates && (
          <div className={styles.whenContainer}>
            <h3 className={styles.whenHeader}>When</h3>
            <div
              className={styles.when}
              dangerouslySetInnerHTML={{ __html: plan.preset_dates }}
            />
            <hr />
          </div>
        )}
        <div className={styles.whatContainer}>
          <h3 className={styles.whatHeader}>What</h3>
          <div
            className={styles.what}
            dangerouslySetInnerHTML={{ __html: plan.description }}
          />
        </div>
        <div className={styles.ctaContainer}>
          <button className="apple lg font-heavy font-lg" onClick={onCtaClick}>
            Purchase This Service
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PlanModal;
